module.exports = __webpack_public_path__ + "img/Hickory V3 960x540.8ffe9cbe.png";